import type { ReactNode } from 'react'
import IconCheck from '@/shared/icons/NewDesign/IconCheck'
import type { ShellSelectMenuItem } from './useShellSelect'
import { PoleCheck, PoleOption, SelectOptionSub, SelectOptionText, SelectOptionTile } from './styled-components'

interface ShellSelectMenuOptionProps {
  item: ShellSelectMenuItem
  icon?: (size: number) => ReactNode
}

const ShellSelectMenuOption = ({ item, icon }: ShellSelectMenuOptionProps) => (
  <PoleOption
    type='button'
    role='option'
    aria-selected={item.isSelected}
    $selected={item.isSelected}
    onClick={item.onChoose}
  >
    {icon && <SelectOptionTile $onTint={item.isSelected}>{icon(18)}</SelectOptionTile>}
    <SelectOptionText>
      {item.title}
      {item.subtitle && <SelectOptionSub>{item.subtitle}</SelectOptionSub>}
    </SelectOptionText>
    <PoleCheck $visible={item.isSelected}>
      <IconCheck size={18} />
    </PoleCheck>
  </PoleOption>
)

export default ShellSelectMenuOption
